export default __webpack_public_path__ + "static/media/home-preview-app-landing.357d610d.jpg";